module.exports = __webpack_public_path__ + "media/images/icons/outlined/function-0553d4d6cbb9b9ed585b893676759634.svg";